export interface AccountSearchCandidate {
  account_number?: string;
  flat?: {
    flat_number?: string;
  };
  owners?: Array<{
    full_name?: string;
    email?: string;
  }>;
}

export const matchesAccountSearch = (
  account: AccountSearchCandidate,
  query: string
): boolean => {
  const normalizedQuery = (query || '').trim().toLowerCase();
  if (!normalizedQuery) return true;

  const accountNumber = (account.account_number || '').toLowerCase();
  const flatNumber = (account.flat?.flat_number || '').toLowerCase();
  const ownerName = (account.owners || [])
    .map(owner => (owner.full_name || '').toLowerCase())
    .join(' ');
  const ownerEmail = (account.owners || [])
    .map(owner => (owner.email || '').toLowerCase())
    .join(' ');

  return [accountNumber, flatNumber, ownerName, ownerEmail]
    .some(value => value.includes(normalizedQuery));
};
